import _isUndefined from 'lodash/isUndefined';
import _reduce from 'lodash/reduce';

/**
 * @module tools/translit
 *
 * @description
 * Производим транслитерацию строки
 *
 * @private
 */

class Translit  {
  constructor () {
    let space = '_';

     this['translit'] = {
      'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'e', 'ж': 'zh',
      'з': 'z', 'и': 'i', 'й': 'j', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
      'о': 'o', 'п': 'p', 'р': 'r','с': 's', 'т': 't', 'у': 'u', 'ф': 'f', 'х': 'h',
      'ц': 'c', 'ч': 'ch', 'ш': 'sh', 'щ': 'sh','ъ': space, 'ы': 'y', 'ь': space, 'э': 'e', 'ю': 'yu', 'я': 'ya',
      ' ': space, '_': space, '`': space, '~': space, '!': space, '@': space,
      '#': space, '$': space, '%': space, '^': space, '&': space, '*': space,
      '(': space, ')': space,'-': space, '\=': space, '+': space, '[': space,
      ']': space, '\\': space, '|': space, '/': space,'.': space, ',': space,
      '{': space, '}': space, '\'': space, '"': space, ';': space, ':': space,
      '?': space, '<': space, '>': space, '№':space
    };
  }


  /**
   * Основной метод.
   * @memberof module:tools/translit
   *
   */
   replace (string: string) {

    return _reduce(string.toLowerCase(), (test: string, symbol: string) => {
      if (!_isUndefined(this['translit'][symbol])) {
        test += this['translit'][symbol];
      } else {
        test += symbol;
      }

      return test;
    }, '');
  }
}

export default Translit;
